import {
  useStudentOnboardingContext,
  setCurrentStep,
} from '../../context/onboardingStudentContext'

const useStepper = () => {
  const [
    { currentStep, isInvitation, stepsLength },
    dispatch,
  ] = useStudentOnboardingContext()

  const setNextStep = () => {
    !isInvitation &&
      currentStep < stepsLength &&
      dispatch(setCurrentStep(currentStep + 1))
  }
  const setPreviousStep = () => {
    !isInvitation &&
      currentStep !== 1 &&
      dispatch(setCurrentStep(currentStep - 1))
  }

  return {
    setNextStep,
    setPreviousStep,
  }
}

export default useStepper
